
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'Notifications',
  data () {
    return {
      source: undefined,
      lastBroadcastAuctionUpdateReloadAt: 0
    }
  },

  computed: {
    ...mapState('product', {
      product: state => state.data
    }),
    ...mapState('messages', ['page']),

    ...mapState('upload', {
      uploadProduct: state => state.product
    }),

    ...mapState('customer', {
      customer: state => state.customer,
      merchantAcceptedByCm24: state => state.merchant?.acceptedByCm24 === true,
      merchantInReview: state => state.merchant?.merchantId && state.merchant?.acceptedByCm24 === null,
      watchlistProducts: state => state.watchlistProducts,
      watchlistPage: state => state.watchlistPage,
      adsProducts: state => state.adsProducts,
      adsPage: state => state.adsPage,
      purchasesProducts: state => state.purchasesProducts,
      purchasesPage: state => state.purchasesPage,
      justAcceptedOffer: state => state.justAcceptedOffer

    })
  },

  async mounted () {
    // console.log(this.$route.name)
    await this.getNotifications({ page: this.page })

    try {
      await this.connect()
    } catch (e) {
      console.error(e)
      await this.reconnect()
    }
  },

  methods: {
    ...mapMutations('messages', [
      'setLoading'
    ]),
    ...mapActions('messages', [
      'pushNotification',
      'getNotifications'
    ]),
    ...mapActions('catalog', ['getProducts']),
    ...mapActions('product', ['getProduct']),
    ...mapActions('customer', [
      'getWatchlist',
      'getAds',
      'getPurchases'
    ]),
    ...mapActions('upload', {
      getUploadProduct: 'getProduct'
    }),

    destroy () {
      if (this.source) {
        this.source.close()
      }
      delete this.source
    },

    async reloadWatchlist (auctionId) {
      if (auctionId) {
        const found = this.watchlistProducts.find(p => p.auction.auctionId === auctionId)
        if (found) {
          await this.getWatchlist(this.$route.query)
        }
      } else {
        await this.getWatchlist(this.$route.query)
      }
    },

    async reloadMyAds (auctionId) {
      if (this.justAcceptedOffer) {
        return
      }

      if (auctionId) {
        const found = this.adsProducts.find(p => p.auction.auctionId === auctionId)
        if (found) {
          await this.getAds(this.adsPage)
        }
      } else {
        await this.getAds(this.adsPage)
      }
    },

    async reloadMyAd () {
      if (this.uploadProduct?.entityId) {
        await this.getUploadProduct(this.uploadProduct?.entityId)
      }
    },

    async reloadMyPurchases (auctionId) {
      if (auctionId !== undefined && auctionId !== null) {
        const found = this.purchasesProducts.find(p => p.auction.auctionId === auctionId)
        if (found) {
          await this.getPurchases(this.purchasesPage)
        }
      }
    },

    async reloadProduct (auctionId) {
      if (auctionId && this.product?.auction?.auctionId === auctionId) {
        await this.getProduct(this.product?.entityId)
      }
    },

    async reloadProducts () {
      await this.getProducts(this.$route.query)
    },

    async reconnect () {
      console.log('Reconnecting to notifications')
      // if (this.$auth.loggedIn) {
      //   console.log('refreshing tokens .... ')
      //   await this.$auth.refreshTokens()
      // }

      this.destroy()
      await this.connect()
    },

    async compareAndGet () {
      if (!this.$auth.loggedIn) {
        return null
      }

      const current = this.$auth.strategy.token.get()
      if (!current) {
        return null
      }

      // Try to decode and check exp
      try {
        const payload = JSON.parse(atob(current.split('.')[1] || ''))
        const now = Math.floor(Date.now() / 1000)
        const exp = payload?.exp ?? 0

        if (exp - now < 60) {
          console.log('Token is expiring soon, refreshing ...')
          // refresh and return the new token
          await this.$auth.refreshTokens()
          return this.$auth.strategy.token.get()
        }
      } catch (_) {
        // if decode fails, just use the current token
        return current
      }

      return current
    },

    async connect () {
      console.log('Connecting to notifications')

      const urlParams = new URLSearchParams({ storeCode: this.$i18n.locale })

      const token = await this.compareAndGet()

      if (token) {
        urlParams.append('token', token)
      }

      const url = `${this.$config.apiBaseURL}/notifications/get-sse?${urlParams}`

      if (!url.startsWith('http')) {
        return
      }

      this.source = new EventSource(url, { withCredentials: true })
      const that = this

      window.onbeforeunload = () => {
        that.source?.close()
      }

      this.source.onopen = function () {
        console.log('Connected to notifications')
      }

      this.source.onerror = (event) => {
        setTimeout(async () => {
          await that.reconnect()
          try {
            if (
              (that.$route.name.startsWith('all___') ||
                that.$route.name.startsWith('catalog-product-id'))) {
              if (that.product?.entityId) {
                await that.getProduct(that.product?.entityId)
              }
            } else if (that.$route.name.startsWith('catalog___')) {
              await that.reloadProducts()
            } else if (that.$route.name.startsWith('account-merchant-watchlist')) {
              await that.reloadWatchlist()
            } else if (that.$route.name.startsWith('account-my-vehicles')) {
              await that.reloadMyAds()
            }
          } catch (e) {
            console.warn('sse connection had an error', e)
          }
        }, 3000)
      }

      this.source.onmessage = async (event) => {
        try {
          const notification = JSON.parse(event.data)
          // console.log('Notification received: ', notification)
          if (notification.message !== null) {
            if (
              (this.$route.name.startsWith('all___') || this.$route.name.startsWith('catalog-product')) &&
              notification.message.callToActionTypeCode === 'broadcast_auction_update'
            ) {
              if (this.product?.auction?.auctionId === notification.message.auctionId) {
                await this.reloadProduct(notification.message.auctionId)
              }
            } else if (this.$route.name.startsWith('catalog___') && notification.message.callToActionTypeCode === 'broadcast_auction_update') {
              const now = Date.now()
              // console.log('Received broadcast auction update notification', notification)
              if (notification.notificationId === -1) {
                await this.reloadProducts()
              } else if (now - this.lastBroadcastAuctionUpdateReloadAt > 3000) {
                this.lastBroadcastAuctionUpdateReloadAt = now
                await this.reloadProducts()
              } else {
                console.log('Skipping reloadProducts due to recent broadcast auction update', notification)
              }
            } else if (this.$route.name.startsWith('account-merchant-watchlist') && (notification.message.callToActionTypeCode === 'broadcast_auction_update' ||
              notification.message.callToActionTypeCode === 'highest_bidder_accept_owners_counteroffer_or_send_new_offer_or_decline')) {
              // IMPORTANT: reload my purchases before reload watchlist
              await this.reloadMyPurchases(notification.message.auctionId)
              await this.reloadWatchlist(notification.message.auctionId)
            } else if (this.$route.name.startsWith('account-my-vehicles') && (notification.message.callToActionTypeCode === 'broadcast_auction_update' ||
              notification.message.callToActionTypeCode === 'owner_accept_offer_from_highest_bidder_or_send_counteroffer_or_decline')
            ) {
              await this.reloadMyAds(notification.message.auctionId)
            } else if (this.$route.name.startsWith('ad-edit') && notification.message.callToActionTypeCode === 'ad_edited') {
              await this.reloadMyAd()
            } else if (this.$route.name.startsWith('index___') && notification.message.callToActionTypeCode === 'broadcast_auction_update') {
              await this.reloadMyAd()
            }

            if (notification.message.messageId !== undefined && notification.message.callToActionTypeCode !== 'broadcast_auction_update' &&
              notification.message.callToActionTypeCode !== 'ad_edited'
            ) {
              await this.pushNotification(notification)
            }
          }
        } catch (error) {

        }
      }
    }

  }

}
